export function ButtonGroupHeaderViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({

    template: [
      '<div class="html-element button-group-header">',
         services.$translate.instant('parameters/quick_replies/details/graph/button_group_header'),
      '  <span class="button-group-header-text"></span>',
      '</div>'
    ].join(''),

    updateBox: function() {
      if(this.paper) {
        const text = this.model.get('groupIndex') + '/' + this.model.get('totalGroupsNumber');
        this.$box.find('.button-group-header-text').text(text);
      }
      joint.shapes.html.AbstractElementView.prototype.updateBox.apply(this, arguments);
    },

  });
}
